import React from 'react';
import { Box, Typography } from '@mui/material';

interface MessageProps {
  message: any;
}

const MessageVideo: React.FC<MessageProps> = ({ message }) => {
  const videoUrl =
    message?.content?.media?.url ||
    message?.content?.url ||
    message?.content?.media?.s3_object?.url ||
    '';
  const bodyText = message?.content?.body?.text || '';
  if (!videoUrl) {
    console.warn('Empty video URL:', videoUrl);
    return null;
  }

  return (
    <Box>
      <video
        controls
        style={{
          width: '100%',
          borderRadius: 8,
          maxHeight: 280,
          backgroundColor: '#000',
        }}
      >
        <source src={videoUrl} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      {/* Caption Text */}
      {bodyText && (
        <Typography variant="body2" mt={1} sx={{ whiteSpace: 'pre-line' }}>
          {bodyText}
        </Typography>
      )}

    </Box>
  );
};

export default MessageVideo;
